import { Component, OnInit } from "@angular/core";
import { NavigationService } from "../../services/navigation.service";
import { forkJoin, switchMap } from "rxjs";
import { LocationStrategy } from '@angular/common';
import { JourneySectionHelperService } from "../../services/journey-section-helper.service";
import { Router } from "@angular/router";
import { LocaleService } from "../../services/locale.service";
import { ContentService } from "../../services/content.service";
import { ProfileInfo } from "../../models/donorProfile.model";

@Component({
  selector: "app-pre-initial-screen",
  templateUrl: "./pre-initial-screen.component.html",
  styleUrl: "./pre-initial-screen.component.scss",
})
export class PreInitialScreenComponent implements OnInit {
  constructor(
    private navigationService: NavigationService,
    private journeyHelper: JourneySectionHelperService,
    private router: Router,
    private locationStrategy: LocationStrategy,
    private localeService: LocaleService,
    private contentService: ContentService
  ) {}

  loading = true;
  sections: any[] = [];
  profileInfo: ProfileInfo | null = null;
  selectedLocale = "en";
  languageOptions = [
    { label: "English", value: "en" },
    { label: "Spanish", value: "es" },
  ];

  ngOnInit(): void {
    this.loading = true;



    forkJoin([
      this.journeyHelper.ensureDonorProfileExists(),
      this.journeyHelper.ensureJourneySectionsExist()
    ]).subscribe({
      next: ([profileInfo, sections]) => {
        const donorProfileInfo = profileInfo as ProfileInfo;

        this.loading = false;
        this.sections = sections;
        this.profileInfo = donorProfileInfo?.data ? donorProfileInfo : null;
        this.selectedLocale =
          this.profileInfo?.data.donor.locale ||
          this.profileInfo?.data.donor.preferredLocale ||
          this.localeService.currentLocale;
        this.localeService.setLocale(this.selectedLocale);
       
      },
      error: (err) => {
        console.error('Initialization failed:', err);
        this.loading = false;
      }
    });
  }

  handleLanguageChange(locale: string) {
    this.selectedLocale = locale;
    this.localeService.setLocale(locale);

    if (this.profileInfo?.data?.donor) {
      this.profileInfo = {
        data: {
          ...this.profileInfo.data,
          donor: {
            ...this.profileInfo.data.donor,
            locale,
            preferredLocale: locale,
          },
        },
      };
    }
  }

  handleButtonClick() {
    this.loading = true;
    this.contentService
      .updateDonorLocale(this.selectedLocale)
      .pipe(
        switchMap(() =>
          this.journeyHelper.updateSectionStatus(
            this.sections[0].sectionId,
            "In Progress"
          )
        )
      )
      .subscribe({
      next: () => {
        this.router.navigate(['/questionnaire/iquestionnaire']).then(() => {
          this.locationStrategy.replaceState({}, '', '/questionnaire/iquestionnaire', '');
          this.loading = false;
        });
      },
      error: (err) => {
        console.error("Failed to save preferred questionnaire language", err);
        this.loading = false;
      },
    });
   
  }
}
